import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-twq-not-found-data',
    templateUrl: './twq-not-found-data.component.html',
    styleUrls: ['./twq-not-found-data.component.scss']
})
export class TwqNotFoundDataComponent {
    @Input() message: string | undefined = 'noDataAvailable';
}
